import { PageHeader } from "../../shared/ui/PageHeader";
import { ContentSection } from "./ContentSection";
import { PhonePreview } from "./PhonePreview";

/**
 * Zalo Mini App management (#18669 P1b) — bind the clinic's Mini App (OA/binding settings) then
 * see what patients currently see. Publishing MOVED to Addy Sites (ADR-0041 Addendum A): building
 * and shipping a channel artifact is not a hospital responsibility, and every future channel would
 * otherwise add its own publish pipeline here. What is left is the half HIS must keep — the binding
 * is consulted pre-auth on patient login — plus a preview and a door to where the rest lives.
 *
 * <p>ONE Mini App per clinic — the brand picker that briefly sat here is gone. Nothing downstream
 * varied by brand: the Mini App reads its content from Addy Sites keyed on the clinic's slug
 * (`COALESCE(website.slug, tenant.code)`), so a second brand's app served byte-identical content.
 * A real multi-brand group needs a tenant per brand anyway, since website, slug and content are all
 * per tenant. The `brand_key` column stays: with brand always NULL its unique index is exactly
 * "one enabled Mini App per clinic", which is the rule we want. See #18687.
 */
export function MiniAppPage() {
  return (
    <div className="mx-auto max-w-6xl">
      <PageHeader
        title="Zalo Mini App"
        description="Liên kết Mini App với phòng khám và xem app đang hiện gì. Nội dung, giao diện và phát hành làm ở Addy Sites."
      />

      {/*
        Điện thoại sang một bên, phần thao tác chiếm phần còn lại.
        Xếp dọc thì khung máy cao 620px đẩy mọi ô nhập xuống dưới màn hình: mở trang ra là phải
        cuộn mới thấy thứ mình vào đây để làm.

        Cột phải là bề rộng CỐ ĐỊNH chứ không phải `3fr`: khung máy rộng đúng 340px, một cột co
        giãn sẽ bóp méo nó ở màn hẹp. 380px trên khung 1152px ≈ đúng 3/10 như mong muốn, và phần
        thừa co giãn thuộc về cột trái — nơi các ô nhập thật sự cần bề rộng.
      */}
      <div className="grid items-start gap-4 lg:grid-cols-[minmax(0,1fr)_380px]">
        <div className="min-w-0 space-y-4">
          {/* Nội dung/giao diện sống ở Addy Sites — CMS theo phòng khám. */}
          <ContentSection />
        </div>

        {/* Dính khi cuộn: xem trước chỉ có ích khi còn nhìn thấy lúc đang sửa ô bên trái. */}
        <PhonePreview className="lg:sticky lg:top-4" />
      </div>
    </div>
  );
}
